var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { faCalendar } from "@fortawesome/free-regular-svg-icons";
import { faChevronLeft, faChevronRight, faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import React from "react";
import { createRoot } from "react-dom/client";
import isEqual from "react-fast-compare";
import { getConfigVar } from "../../utils/Configuration";
import { addCheckClickOutside, checkKey, concatClassNames, createElementWithClass, getCalendar, trackOnElement } from "../../utils/Functions";
import { Button } from "../layout/Button";
import { Tooltip } from "../layout/Tooltip";
import { BaseInput } from "./BaseInput";
import { Timepicker } from "./Timepicker";
var Datepicker = /** @class */ (function (_super) {
    __extends(Datepicker, _super);
    function Datepicker(props) {
        var _this = this;
        var dateToUse = props.defaultValue || new Date();
        _this = _super.call(this, props, {
            show: null,
            params: {
                day: dateToUse.getDate(),
                month: dateToUse.getMonth(),
                year: dateToUse.getFullYear()
            }
        }, props.defaultValue || null) || this;
        _this.DEFAULT_FORMAT_TIME = "DD/MM/yyyy HH:mm";
        _this.pickerContainer = createElementWithClass("div", "dolfo-datepicker-select");
        _this.componentDidMount = function () { return addCheckClickOutside(_this.blurInput, _this, _this.pickerContainer); };
        _this.componentWillUnmount = function () { return setTimeout(function () {
            var _a;
            (_a = _this.pickerRoot) === null || _a === void 0 ? void 0 : _a.unmount();
            _this.pickerContainer.remove();
        }); };
        _this.componentDidUpdate = function (prevProps, prevState) {
            var _a, _b, _c, _d;
            if (((_a = prevProps.defaultValue) === null || _a === void 0 ? void 0 : _a.getTime()) !== ((_b = _this.props.defaultValue) === null || _b === void 0 ? void 0 : _b.getTime()))
                _this.dispatchValue(_this.props.defaultValue);
            if (prevState.show !== _this.state.show || ((_c = prevState.value) === null || _c === void 0 ? void 0 : _c.getTime()) !== ((_d = _this.state.value) === null || _d === void 0 ? void 0 : _d.getTime()) || !isEqual(prevState.params, _this.state.params)) {
                var _e = _this.state, show_1 = _e.show, params_1 = _e.params, value_1 = _e.value, _f = _this.props, showToday = _f.showToday, selectTime = _f.selectTime, timeFormat = _f.timeFormat, select = _f.select;
                if (!show_1 && _this.pickerRoot) {
                    setTimeout(function () {
                        if (_this.pickerRoot)
                            _this.pickerRoot.unmount();
                        _this.pickerContainer.remove();
                        _this.pickerRoot = null;
                    });
                }
                else if (show_1) {
                    if (!_this.pickerRoot)
                        _this.pickerRoot = createRoot(_this.pickerContainer);
                    if (show_1 === "years") {
                        var years = _this.getYears();
                        _this.pickerRoot.render(React.createElement("table", null,
                            React.createElement("thead", null,
                                React.createElement("tr", { className: "buttons" },
                                    React.createElement("th", null,
                                        React.createElement(Tooltip, { label: getConfigVar("PREVIOUS") },
                                            React.createElement(Button, { size: "small", color: "white", shape: "pill", onClick: function (e) {
                                                    e.stopPropagation();
                                                    _this.updateParams({ year: params_1.year - 10 });
                                                    _this.setShowing(show_1);
                                                } },
                                                React.createElement(FontAwesomeIcon, { icon: faChevronLeft })))),
                                    React.createElement("th", null, params_1.year),
                                    React.createElement("th", null,
                                        React.createElement(Tooltip, { label: getConfigVar("NEXT") },
                                            React.createElement(Button, { size: "small", color: "white", shape: "pill", onClick: function (e) {
                                                    e.stopPropagation();
                                                    _this.updateParams({ year: params_1.year + 10 });
                                                    _this.setShowing(show_1);
                                                } },
                                                React.createElement(FontAwesomeIcon, { icon: faChevronRight })))))),
                            React.createElement("tbody", null, years.map(function (row, i) { return React.createElement("tr", { key: i }, row.map(function (year) {
                                var select = function () {
                                    _this.updateParams({ year: year });
                                    _this.setShowing("days");
                                }, node = [];
                                node.push(React.createElement("td", { className: concatClassNames(new Date().getFullYear() === year ? "today" : null, "year"), key: year, tabIndex: 0, onClick: function (e) {
                                        e.stopPropagation();
                                        select();
                                    }, onKeyUp: function (e) { return checkKey(e, select); } }, year));
                                if (year === params_1.year + 9) {
                                    node.splice(0, 0, React.createElement("td", { key: "void-1", className: "other-month" }));
                                    node.splice(node.length, 0, React.createElement("td", { key: "void-2", className: "other-month" }));
                                }
                                return node;
                            })); }))));
                    }
                    else if (show_1 === "months") {
                        var months = _this.getMonths();
                        _this.pickerRoot.render(React.createElement("table", null,
                            React.createElement("tbody", null, months.map(function (row, i) { return React.createElement("tr", { key: i }, row.map(function (month) {
                                var select = function () {
                                    _this.updateParams({ month: month });
                                    _this.setShowing("days");
                                };
                                return React.createElement("td", { key: month, onClick: function (e) {
                                        e.stopPropagation();
                                        select();
                                    }, className: "month", onKeyUp: function (e) { return checkKey(e, select); }, tabIndex: 0 }, getConfigVar("MONTH_" + (month + 1)).substring(0, 3));
                            })); }))));
                    }
                    else if (show_1 === "days") {
                        var calendar = getCalendar(params_1.year, params_1.month);
                        _this.pickerRoot.render(React.createElement("table", null,
                            React.createElement("thead", null,
                                React.createElement("tr", { className: "buttons" },
                                    React.createElement("th", null,
                                        React.createElement(Tooltip, { label: getConfigVar("PREVIOUS") },
                                            React.createElement(Button, { size: "small", color: "white", shape: "pill", onClick: function (e) {
                                                    e.stopPropagation();
                                                    _this.updateParams({
                                                        month: params_1.month === 0 ? 11 : params_1.month - 1,
                                                        year: params_1.month === 0 ? params_1.year - 1 : params_1.year
                                                    });
                                                    _this.setShowing(show_1);
                                                } },
                                                React.createElement(FontAwesomeIcon, { icon: faChevronLeft })))),
                                    React.createElement("th", { colSpan: 3 },
                                        React.createElement(Tooltip, { label: getConfigVar("SELECT") },
                                            React.createElement(Button, { size: "small", color: "white", shape: "pill", onClick: function (e) {
                                                    e.stopPropagation();
                                                    _this.setShowing("months");
                                                    _this.fixPickerSize();
                                                } }, _this.decodeMonth()))),
                                    React.createElement("th", { colSpan: 2 },
                                        React.createElement(Tooltip, { label: getConfigVar("SELECT") },
                                            React.createElement(Button, { size: "small", color: "white", shape: "pill", onClick: function (e) {
                                                    var year = new Date().getFullYear().toString();
                                                    e.stopPropagation();
                                                    _this.updateParams({
                                                        year: Number(year.substring(0, year.length - 1) + "0")
                                                    });
                                                    _this.fixPickerSize();
                                                    _this.setShowing("years");
                                                } }, params_1.year))),
                                    React.createElement("th", null,
                                        React.createElement(Tooltip, { label: getConfigVar("NEXT") },
                                            React.createElement(Button, { size: "small", color: "white", shape: "pill", onClick: function (e) {
                                                    e.stopPropagation();
                                                    _this.updateParams({
                                                        month: params_1.month === 11 ? 0 : params_1.month + 1,
                                                        year: params_1.month === 11 ? params_1.year + 1 : params_1.year
                                                    });
                                                    _this.setShowing(show_1);
                                                } },
                                                React.createElement(FontAwesomeIcon, { icon: faChevronRight }))))),
                                React.createElement("tr", null,
                                    React.createElement("th", null, _this.getFirstLetter(1)),
                                    React.createElement("th", null, _this.getFirstLetter(2)),
                                    React.createElement("th", null, _this.getFirstLetter(3)),
                                    React.createElement("th", null, _this.getFirstLetter(4)),
                                    React.createElement("th", null, _this.getFirstLetter(5)),
                                    React.createElement("th", null, _this.getFirstLetter(6)),
                                    React.createElement("th", null, _this.getFirstLetter(7)))),
                            React.createElement("tbody", null,
                                calendar.map(function (row, i) { return React.createElement("tr", { key: i }, row.map(function (n, i2) {
                                    var numberN = Number(n), nDate = new Date(params_1.year, params_1.month, numberN), isOther = n.toString().indexOf("_") >= 0, select = function () {
                                        if (!isNaN(numberN) && numberN > 0) {
                                            _this.dispatchValue(nDate);
                                            _this.setShowing(null);
                                        }
                                    }, today = new Date(), isToday = today.getFullYear() === nDate.getFullYear() && today.getDate() === nDate.getDate() && today.getMonth() === nDate.getMonth();
                                    nDate.setHours(0, 0, 0, 0);
                                    return React.createElement("td", { key: n + "-" + i2, className: concatClassNames([
                                            isOther ? "other-month" : "",
                                            isToday ? "today" : ""
                                        ], value_1 && nDate.getTime() === value_1.getTime() ? "current" : ""), onClick: select, tabIndex: !isOther ? 0 : null, onKeyDown: function (e) { return checkKey(e, select); } }, n.toString().replace("_", ""));
                                })); }),
                                showToday && React.createElement("tr", null,
                                    React.createElement("td", { colSpan: 7, className: "select-today" },
                                        React.createElement(Button, { color: "white", shape: "pill", onClick: function () {
                                                _this.dispatchValue(new Date());
                                                _this.setShowing(null);
                                            } }, getConfigVar("TODAY")))),
                                selectTime && React.createElement("tr", null,
                                    React.createElement("td", { colSpan: 7, className: "time" },
                                        React.createElement(Timepicker, { ref: function (r) { return _this.timePicker = r; }, defaultValue: value_1, onChange: function (v) { return _this.dispatchValue(v); }, timeFormat: timeFormat, select: select }))))));
                    }
                    document.body.appendChild(_this.pickerContainer);
                    trackOnElement(_this.pickerContainer, _this, true, false);
                }
            }
        };
        _this.fixPickerSize = function () {
            var _a = _this.pickerContainer.getBoundingClientRect(), height = _a.height, width = _a.width;
            _this.pickerContainer.style.width = width + "px";
            _this.pickerContainer.style.height = height + "px";
        };
        _this.decodeMonth = function () {
            var month = _this.state.params.month;
            return getConfigVar("MONTH_" + (month + 1));
        };
        _this.updateParams = function (params) { return _this.setState({
            params: __assign(__assign({}, _this.state.params), params)
        }); };
        _this.getFirstLetter = function (day) {
            var dayString = getConfigVar("WEEK_DAY_" + day);
            return dayString[0].toUpperCase();
        };
        _this.restartParams = function () {
            var value = _this.state.value, date = value || new Date();
            _this.updateParams({
                day: date.getDate(),
                month: date.getMonth(),
                year: date.getFullYear()
            });
        };
        _this.setShowing = function (show) { return _this.setState({ show: show }); };
        _this.onChange = function (e) {
            var _a = _this.props, onChange = _a.onChange, disabled = _a.disabled, selectTime = _a.selectTime, value = e.target.value, date = value ? new Date(value) : null;
            if (!selectTime && value)
                date.setHours(0, 0);
            if (disabled)
                return;
            _this.setState({ value: date, show: "days" }, function () {
                if (onChange)
                    onChange(date, e);
                _this.restartParams();
            });
        };
        _this.getYears = function () {
            var rows = [], year = _this.state.params.year;
            var row = [];
            for (var i = year; i < year + 10; i++) {
                if (row.length === 3) {
                    rows.push(row);
                    row = [];
                }
                row.push(i);
                if (i === year + 9)
                    rows.push(row);
            }
            return rows;
        };
        _this.getMonths = function () {
            var rows = [];
            var row = [];
            for (var i = 0; i < 12; i++) {
                if (row.length === 3) {
                    rows.push(row);
                    row = [];
                }
                row.push(i);
                if (i === 11)
                    rows.push(row);
            }
            return rows;
        };
        _this.getFormat = function () { return _this.props.dateFormat || (_this.props.selectTime ? _this.DEFAULT_FORMAT_TIME : Datepicker.DEFAULT_FORMAT); };
        _this.decodeDate = function () {
            var value = _this.state.value;
            if (!value || isNaN(value.getTime()))
                return "";
            return moment(new Date(value)).format(_this.getFormat());
        };
        _this.focusInput = function (e) {
            var _a = _this.props, onFocus = _a.onFocus, disabled = _a.disabled;
            if (disabled)
                return;
            _this.setShowing("days");
            if (onFocus)
                onFocus(e);
        };
        _this.blurInput = function (e) {
            var target = e.target;
            if (_this.pickerContainer.isEqualNode(target) || _this.pickerContainer.contains(target)) {
                if (_this.timePicker)
                    _this.timePicker.blurInput(e);
                return;
            }
            if (_this.timePicker && !_this.timePicker.blurInput(e))
                return;
            _this.setShowing(null);
            _this.restartParams();
        };
        _this.checkInternalValue = function (e) {
            var _a = _this.props, onBlur = _a.onBlur, disabled = _a.disabled, internalValue = _this.state.internalValue;
            if (disabled)
                return;
            if (internalValue != null) {
                var momentDate = moment(internalValue, _this.getFormat());
                if (momentDate.isValid())
                    _this.dispatchValue(momentDate.toDate());
                else
                    _this.dispatchValue(undefined);
                _this.setInternalValue(null);
                _this.restartParams();
                _this.setShowing(null);
                if (onBlur)
                    onBlur(e);
            }
            else if (onBlur)
                onBlur(e);
        };
        _this.render = function () {
            var _a = _this.props, required = _a.required, disabled = _a.disabled, className = _a.className, style = _a.style, _b = _this.state, value = _b.value, internalValue = _b.internalValue;
            return React.createElement("div", { className: "dolfo-control datepicker", ref: function (r) { return _this.node = r; } },
                _this.getLabel(),
                React.createElement("div", { className: "dolfo-input-container" },
                    React.createElement("input", { type: "text", onChange: function (e) {
                            var value = e.target.value, momentDate = moment(new Date(value), _this.getFormat()), date = momentDate.toDate(), nativeEvent = e.nativeEvent;
                            if (nativeEvent.isBase) {
                                if (!value) {
                                    _this.onChange(e);
                                    return;
                                }
                                e.target.value = !momentDate.isValid() ? null : date.toString();
                                _this.onChange(e);
                            }
                            else
                                _this.setInternalValue(value);
                        }, onKeyDown: function (e) {
                            if (e.code === "Tab")
                                _this.blurInput(new Event(e.type, e));
                            else if (e.code === "Enter")
                                _this.checkInternalValue(e);
                        }, value: internalValue != null ? internalValue : _this.decodeDate(), required: required, disabled: disabled, onFocus: _this.focusInput, onBlur: _this.checkInternalValue, className: concatClassNames(["dolfo-picker-input", "dolfo-input-text"], className), style: style, autoComplete: "new-password", ref: function (r) { return _this.input = r; } }),
                    !disabled && value && React.createElement(Tooltip, { label: getConfigVar("RESET"), position: "left" },
                        React.createElement(FontAwesomeIcon, { icon: faXmark, className: "dolfo-input-reset", onClick: _this.reset })),
                    !disabled && React.createElement(Tooltip, { label: getConfigVar("SELECT"), position: "left" },
                        React.createElement(Button, { className: "dolfo-picker-btn", onClick: function () { return _this.input.focus(); }, size: "small", color: "white" },
                            React.createElement(FontAwesomeIcon, { icon: faCalendar })))));
        };
        return _this;
    }
    Datepicker.DEFAULT_FORMAT = "DD/MM/yyyy";
    return Datepicker;
}(BaseInput));
export { Datepicker };
